<template>
  <nav class="navbar navbar-expand-sm navbar-light fixed-top bgwhite py-1">
    <div class="container-fluid navbar-header">
      <div class="logo-brand-container">
        <div class="logo-left">
          <img src="/logo.svg" />
        </div>
        <h3>Interio Inc.</h3>
      </div>
      <button
        class="navbar-toggler navbar-toggler-right"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#mynavbar"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="mynavbar">
        <ul class="navbar-nav me-auto ps-sm-5 ms-sm-5">
          <!-- Home -->
          <li class="nav-item">
            <router-link
              to="/"
              class="nav-link fw-bold"
              tag="button"
              active-class="active"
              >Home</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/services"
              class="nav-link fw-bold"
              tag="button"
              active-class="active"
              >Services</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/gamedev"
              class="nav-link fw-bold"
              tag="button"
              active-class="active"
              >Game Dev</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/Contact"
              class="nav-link fw-bold"
              tag="button"
              active-class="active"
              >Contact Us</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/about"
              class="nav-link fw-bold"
              tag="button"
              active-class="active"
              >About Us</router-link
            >
          </li>
        </ul>
        <!--
        <div class="d-sm-flex text-center pe-sm-5 me-sm-5 my-4 my-md-0">
          <a href="#" class="mx-4"
            ><fa :icon="['fab', 'facebook']" class="fa fb"
          /></a>
          <a href="#" class="mx-4"
            ><fa :icon="['fab', 'twitter']" class="fa tw"
          /></a>
          <a href="#" class="mx-4"
            ><fa :icon="['fab', 'github']" class="fa gh"
          /></a>
        </div>
        <div class="btn-group">
          <router-link to="/auth/login" class="btn btn hpink" tag="button"
            >Sign in</router-link
          <router-link to="/auth/login" class="btn btn hblue" tag="button"
            >Sign Up</router-link
          >
        </div>  -->
      </div>
    </div>
  </nav>
</template>

<script>
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { Collapse } from "bootstrap";

export default {
  name: "navbar",
  setup() {
    const router = useRouter();
    let collapseInstance = null;

    onMounted(() => {
      const collapseElement = document.getElementById("mynavbar");
      if (collapseElement) {
        collapseInstance = new Collapse(collapseElement, {
          toggle: false,
        });
      }

      router.afterEach(() => {
        if (
          collapseInstance &&
          collapseElement &&
          collapseElement.classList.contains("show")
        ) {
          collapseInstance.hide();
        }
      });
    });

    onUnmounted(() => {
      if (collapseInstance) {
        collapseInstance.dispose();
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Cabin&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Maven+Pro:wght@500&display=swap");

nav.navbar {
  background-color: #aeddff;
  border-bottom: 1px solid #8ec8ef;
}

.nav-link {
  color: #475569;
}

.nav-link:hover {
  color: #1e293b;
}
.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar-toggler-right {
  margin-left: auto;
}

.logo-brand-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}

.logo-left {
  width: 40px;
  height: 40px;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  img {
    width: 40px;
    height: 40px;
  }
}

.bgwhite {
  background-color: white;
}
.hpink:hover {
  background: #ed64a6;
  color: white;
}
.hblue:hover {
  background: #667eea;
  color: white;
}
nav {
  box-shadow: 0px 0.5px 10px rgb(180, 180, 180);
}
.fa {
  color: #94a3b8;
  font-size: 2.6vh;
}
.fa:hover {
  animation-name: example;
  animation-duration: 2s;
}
.fb:hover {
  color: rgb(0, 102, 255);
}
.tw:hover {
  color: rgb(0, 162, 255);
}
.gh:hover {
  color: black;
}
@keyframes example {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.nav-item a.router-link-exact-active {
  color: #ff5858;
  font-family: "Maven Pro", sans-serif;
}
h3 {
  margin: 0;
  color: #1e293b;
  font-weight: bold;
  font-size: 24px;
  font-family: "Cabin", sans-serif;
}
</style>
